import React, { useState } from 'react';
import { SDialog } from '@avalara/skylab-sdk/react';
import InvalidAddressConfirmation from './invalid-address';
import ValidAddressConfirmation from './valid-address';
const AddressValidationDialog = ({ responseAddresses, dialogVisible, setDialogVisible, setPresetAddress, }) => {
    const { address: userEnteredAddress, validatedAddresses: suggestedAddress } = responseAddresses;
    const isValidAddress = Array.isArray(suggestedAddress) && suggestedAddress.length > 0;
    const allAddresses = [...suggestedAddress, userEnteredAddress];
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [selectedAddress, setSelectedAddress] = useState(allAddresses[0]);
    const handleUseAddress = () => {
        setDialogVisible(false);
        setPresetAddress(selectedAddress);
    };
    const handleCloseDialog = () => {
        setDialogVisible(false);
        setSelectedIndex(0);
        setSelectedAddress(allAddresses[0]);
    };
    return (React.createElement("div", { "data-ref": 'buy.address-validation.dialog' },
        React.createElement(SDialog, { open: dialogVisible, id: "address-validation-dialog", "onS-dismiss": handleCloseDialog },
            isValidAddress ? (React.createElement(ValidAddressConfirmation, { suggestedAddresses: allAddresses, setSelectedAddress: setSelectedAddress, selectedIndex: selectedIndex, setSelectedIndex: setSelectedIndex })) : (React.createElement(InvalidAddressConfirmation, { userEnteredAddress: userEnteredAddress })),
            React.createElement("div", { slot: "footer" },
                React.createElement("button", { className: "primary margin-right-sm", "data-ref": 'buy.address-validation.submit-button', onClick: handleUseAddress }, 'Use this address'),
                React.createElement("button", { className: "secondary", "data-ref": 'buy.address-validation.back-button', onClick: handleCloseDialog }, 'Back')))));
};
export default AddressValidationDialog;
